/** @type {import('next-i18next').UserConfig} */
module.exports = {
  i18n: {
    defaultLocale: 'nl',
    locales: ['nl'],
  },
};
